<template functional>
  <div class="goal-image-picker__tile"
       :class="{active:props.active}"
       v-on="listeners">
    <div class="block">
      <img :src="props.image" :alt="props.image">
      <div class="name" v-if="props.name">{{ props.name }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoalImagePickerTile",
  props: {
    active: {
      type: Boolean
    },
    image: {
      type: String
    },
    name: {
      type: String
    },
    uploaded: {
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.goal-image-picker {
  &__tile {
    @apply p-2 border border-transparent rounded cursor-pointer transition duration-200;
    height: 97px;


    &:hover, &.active {
      @apply border-red;
      .name {
        opacity: 1;
        transform: translateY(0);
      }
    }

    img {
      @apply rounded;
      width: 100%;
      object-fit: cover;
    }
  }

  .block {
    @apply flex overflow-hidden relative max-h-full h-full;
  }

  .name {
    @apply absolute inset-0 top-auto bottom-4
    text-2sm font-medium text-white text-center leading-tight
    bg-black-transparent80
    rounded mx-4 py-3
    transition duration-200;
    opacity: 0;
    transform: translateY(200%);

  }
}
</style>